/* Switching purchase option used to run a text shimmer over the line price for
   the whole round trip. text-component's shimmer sets color:transparent and
   sweeps a pale gradient across the text, so against this light drawer it reads
   as a glow blinking on and then off. The price is replaced wholesale by the
   section morph a beat later, so the shimmer bought nothing but the flicker.
   It also reached for the cart total with a document-wide selector, which would
   grab the FIRST match on the page rather than this cart's own total.
   All the toggle needs is a lock so a fast double click cannot fire two
   requests against the same line. */
function lockCartItems(triggerElement) {
  const cartItems = triggerElement.closest('cart-items-component');
  if (cartItems) {
    cartItems.classList.add('cart-items-disabled');
  }
  return cartItems;
}

/* Released explicitly rather than left to the section morph to clear.
   .cart-items-disabled is pointer-events:none, so if the request fails or the
   morph does not land, the rows would stay dead and the quantity and remove
   controls would silently stop responding. */
function unlockCartItems(cartItems) {
  if (cartItems) {
    cartItems.classList.remove('cart-items-disabled');
  }
}

function getCartSectionIds() {
  const sections = new Set();
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el.dataset.sectionId) {
      sections.add(el.dataset.sectionId);
    }
  });
  return sections;
}

function dispatchCartUpdate(cart, sectionsToUpdate) {
  const sectionId = sectionsToUpdate.values().next().value;
  let itemCount = cart.item_count;

  if (sectionId && cart.sections?.[sectionId]) {
    const doc = new DOMParser().parseFromString(cart.sections[sectionId], 'text/html');
    const countEl = doc.querySelector('[ref="cartItemCount"]');
    if (countEl) {
      itemCount = parseInt(countEl.textContent, 10);
    }
  }

  document.dispatchEvent(
    new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'cart-subscription',
        data: {
          itemCount,
          source: 'cart-subscription',
          sections: cart.sections,
        },
      },
    })
  );
}

function changeSellingPlan(data) {
  const sectionsToUpdate = getCartSectionIds();

  const body = JSON.stringify({
    line: data.line,
    quantity: data.quantity,
    selling_plan: data.selling_plan,
    sections: Array.from(sectionsToUpdate).join(','),
    sections_url: window.location.pathname,
  });

  return fetch(Theme.routes.cart_change_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body,
  })
    .then((response) => response.json())
    .then((cart) => {
      if (cart.errors) {
        console.error('Cart subscription update failed:', cart.errors);
        return null;
      }

      dispatchCartUpdate(cart, sectionsToUpdate);
      return cart;
    });
}

class SubscriptionBtn extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = () => {
    const { sellingPlanId, quantity, index } = this.dataset;

    if (!sellingPlanId || !index) return;

    this.classList.add('subscription-loading');
    const cartItems = lockCartItems(this);

    changeSellingPlan({
      line: parseInt(index, 10),
      quantity: parseInt(quantity, 10),
      selling_plan: parseInt(sellingPlanId, 10),
    })
      .catch((error) => console.error(error))
      .finally(() => {
        this.classList.remove('subscription-loading');
        unlockCartItems(cartItems);
      });
  };
}

class SubscriptionFrequency extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleOptionClick);
    document.addEventListener('click', this.handleOutsideClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleOptionClick);
    document.removeEventListener('click', this.handleOutsideClick);
  }

  handleOutsideClick = (event) => {
    const details = this.querySelector('details');
    if (details && !this.contains(event.target)) {
      details.removeAttribute('open');
    }
  };

  handleOptionClick = (event) => {
    const option = event.target.closest('[js-purchase-option]');
    if (!option) return;

    const { sellingPlanId, quantity, index } = option.dataset;
    if (!index) return;

    const details = this.querySelector('details');
    if (details) details.removeAttribute('open');

    this.classList.add('subscription-loading');
    const cartItems = lockCartItems(this);

    changeSellingPlan({
      line: parseInt(index, 10),
      quantity: parseInt(quantity, 10),
      selling_plan: sellingPlanId !== '' ? parseInt(sellingPlanId, 10) : '',
    })
      .catch((error) => console.error(error))
      .finally(() => {
        this.classList.remove('subscription-loading');
        unlockCartItems(cartItems);
      });
  };
}


if (!customElements.get('subcription-btn')) {
  customElements.define('subcription-btn', SubscriptionBtn);
}

if (!customElements.get('subcription-frequency')) {
  customElements.define('subcription-frequency', SubscriptionFrequency);
}